// extracted by mini-css-extract-plugin
export default {"header":"Banks_header__4zJYu","table":"Banks_table__Lb29o"};